import { render, staticRenderFns } from "./TermsCond.vue?vue&type=template&id=39eebe55&"
import script from "./TermsCond.vue?vue&type=script&lang=js&"
export * from "./TermsCond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports